module.exports = "//d274d294w9cx2v.cloudfront.net/89e10900f7761b509075aa0a6741a2d99896821a/images/payPalBadge.png";